module.exports = __webpack_public_path__ + "img/Slide47.3321fdc3.png";